<template>
  <div class="container">
    <div v-if="!orderbool">
      <h3 class="green subtitle">
        {{ $translate('subtitle_form_model_suola') }}
      </h3>
      <hr />
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          v-if="!orderbool"
          horizontal
          :label="$translate('soles') | capitalize"
          :message="errors.first('available_soles')"
          :type="{ 'is-danger': errors.has('available_soles') }"
        >
          <b-select
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="available_soles"
            v-model="mod.soles"
            multiple
          >
            <template v-if="!mod.shapes || mod.shapes.length === 0">
              <option v-for="sole in availablesoles" :key="sole.id" :value="sole.id">
                {{ sole.commercial_name }}
              </option>
            </template>
            <template v-else>
              <option v-for="sole in filteredSoles" :key="sole.id" :value="sole.id">
                {{ sole.commercial_name }}
              </option>
            </template>
          </b-select>
        </b-field>
        <b-field
          horizontal
          :label="$translate('sole default') | capitalize"
          :message="errors.first('default_sole')"
          :type="{ 'is-danger': errors.has('default_sole') }"
        >
          <b-select
            v-validate="'required|included:' + mod.soles"
            data-vv-validate-on="blur"
            name="default_sole"
            v-model="mod.sole_default"
          >
            <template v-if="!mod.shapes || mod.shapes.length === 0">
              <option v-for="sole in availablesoles" :key="sole.id" :value="sole.id">
                {{ sole.commercial_name }}
              </option>
            </template>
            <template v-else>
              <option v-for="sole in filteredSoles" :key="sole.id" :value="sole.id">
                {{ sole.commercial_name }}
              </option>
            </template>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <img
          :src="defaultImage == null ? 'https://place-hold.it/150x150' : defaultImage"
          style="max-width: 150px; max-height: 150px;"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SoleFits',
  props: ['mod', 'availablesoles', 'disabledbool', 'orderbool', 'orderInfoMandatory', 'isSimplified'],
  inject: ['$validator'],
  computed: {
    defaultImage() {
      const defaultSole = this.availablesoles.find(sole => {
        return sole.id === this.mod.sole_default
      })
      return defaultSole ? defaultSole.image : 'https://place-hold.it/150x150'
    },
    filteredSoles() {
      return (this.availablesoles || []).filter(sole => sole.shapes.some(shape => this.mod.shapes.includes(shape.id)))
    },
  },
  created() {
    if (!this.orderbool) {
      this.mod.soles = []
    }
  },
}
</script>
<style scoped>
.container >>> .column select {
  min-width: 200px;
}
</style>
